import { Action, createFeature, createReducer, on } from '@ngrx/store';
import { initialState, InitState } from '../state/init.state';
import * as initActions from '../actions/init.actions';

export const initFeatureStoreKey: string = 'init';

export const reducers = (state: InitState, action: Action): InitState => {
  return initReducer(state, action);
};

export const initReducer = createReducer(
  initialState,
  on(initActions.getUserSuccess, (state, { accountInfo }) => ({
    ...state,
    accountInfo,
    isUserInfoLoaded: true,
  })),
  on(initActions.getUserError, (state) => ({
    ...state,
    isUserInfoLoaded: true,
  }))
);

export const initFeature = createFeature({
  name: initFeatureStoreKey,
  reducer: reducers,
});
